import {PlayerReduxState} from "../types";

export default function getCurrentMaxIndex(state: PlayerReduxState): number | undefined {
  return state.maxIndexes[state.scenarioIndex];
}